import { useEffect } from "react";

// Lightweight per-page SEO: updates <title> and meta description for SPA routes.
export default function usePageMeta(title, description) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;
    let tag = document.querySelector('meta[name="description"]');
    const prevDesc = tag ? tag.getAttribute("content") : null;
    if (description && tag) tag.setAttribute("content", description);
    return () => {
      document.title = prevTitle;
      if (tag && prevDesc != null) tag.setAttribute("content", prevDesc);
    };
  }, [title, description]);
}
